var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.762 6.818C15.646 6.908 13.598 8.062 13.598 10.628C13.598 13.596 16.204 14.646 16.282 14.672C16.27 14.736 15.868 16.11 14.908 17.51C14.052 18.742 13.158 19.972 11.798 19.972C10.438 19.972 10.088 19.182 8.518 19.182C6.988 19.182 6.444 19.998 5.2 19.998C3.956 19.998 3.088 18.858 2.09 17.458C0.934 15.814 0 13.26 0 10.836C0 6.948 2.528 4.886 5.016 4.886C6.338 4.886 7.44 5.754 8.27 5.754C9.06 5.754 10.292 4.834 11.796 4.834C12.366 4.834 14.414 4.886 15.762 6.818ZM11.082 3.188C11.704 2.45 12.144 1.426 12.144 0.402C12.144 0.26 12.132 0.116 12.106 0C11.094 0.038 9.89 0.674 9.164 1.516C8.594 2.164 8.062 3.188 8.062 4.226C8.062 4.382 8.088 4.538 8.1 4.588C8.164 4.6 8.268 4.614 8.372 4.614C9.28 4.614 10.422 4.006 11.082 3.188Z",
    fill: "#CAD0E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/appleIcon.f43093f8b5e3971eab24baf49d673b2d.svg";
export { ForwardRef as ReactComponent };